import { useTranslation } from 'react-i18next';

import {
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@cfa/react-components';

import { useSetDataView } from '@/atoms/data-view';

interface ToggleButtonProps {
  dataTestId?: string;
  isLicenseeMode: boolean;
  setIsLicenseeMode: (mode: boolean) => void;
}

const ToggleButtons = ({
  dataTestId = 'toggle-buttons',
  isLicenseeMode,
  setIsLicenseeMode,
}: ToggleButtonProps) => {
  const { t } = useTranslation();

  const { resetFilters } = useSetDataView('manage-plans');

  const toggleMyRestaurants = () => {
    setIsLicenseeMode(false);
    resetFilters();
  };

  const toggleLicensee = () => {
    setIsLicenseeMode(true);
    resetFilters();
  };

  return (
    <ToggleButtonGroup
      fullWidth
      orientation="horizontal"
      size="sm"
      data-testid={dataTestId}
      value={isLicenseeMode}
    >
      <ToggleButton
        aria-label="my-restaurants"
        onClick={toggleMyRestaurants}
        value={false}
      >
        <Typography
          fontWeight={isLicenseeMode ? 'regular' : 'bold'}
          variant="body1"
        >
          {t('Licensee.myRestaurants')}
        </Typography>
      </ToggleButton>
      <ToggleButton
        aria-label="licensees"
        onClick={toggleLicensee}
        value={true}
      >
        <Typography
          fontWeight={isLicenseeMode ? 'bold' : 'regular'}
          variant="body1"
        >
          {t('Licensee.licensees')}
        </Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ToggleButtons;
